import { Build } from "@dashboard/products/types";

import { isBuildProcessing } from "./isBuildProcessing";

/**
 * Only a running build can still finish an upload — once it failed, was canceled or skipped, its
 * unfinished artifacts never arrive, so the spinner would keep turning forever.
 */
export const isUploadingArtifacts = (build: Build) =>
    (build.artifacts?.some((artifact) => !artifact.isUploaded) ?? false) && isBuildProcessing(build);
